import React from "react";
import { useHistory } from "react-router";


export const StoreList = () => {

    const history = useHistory()

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="input-group pl-3 w-25">
                <input
                  className="form-control"
                  type="text"
                  placeholder="search..."
                ></input>
                <div className="input-group-prepend">
                  <button
                    className="input-group-text pointer search-btn"
                    style={{ backgroundColor: "#e5e4ec" }}
                  >
                    search
                  </button>
                </div>
              </div>
              <button
                className="btn btn-primary btn-sm w-sm waves-effect waves-light"
                onClick={() => history.push("/add-store")}
              >
                Add Store
              </button>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Retailer Name</th>
                    {/* <th>Type of Retailer</th> */}
                    <th>Contact No.</th>
                    <th>Email</th>
                    <th>Referral Code</th>
                    <th>Store Count</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                 
                </tbody>
              </table>
             
            </div>
          </div>
        </div>
       
      </div>
    </div>
  );
};
